module.exports = "/images/vendor/flag-icon-css/flags/4x3/io.svg?3ddd1280f6e320712021a1f68ee5ae11";